import { render } from "./FullFrameView.vue?vue&type=template&id=da6b974e&scoped=true"
import script from "./FullFrameView.vue?vue&type=script&lang=js"
export * from "./FullFrameView.vue?vue&type=script&lang=js"

import "./FullFrameView.vue?vue&type=style&index=0&id=da6b974e&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da6b974e"]])

export default __exports__